// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2zzQv","search":"Settings_search__Z42Zo","filter":"Settings_filter__1iWVC"};